import SurveyFormat from './surveyFormatEnum';
import { GetCurrentSurveySessionQuery } from '~lib/generatedGqlTypes';

type Survey = NonNullable<GetCurrentSurveySessionQuery['surveyTakingSession']['survey']>;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const extrapolateSurveyData = (survey: Survey) => {
  return {
    isAutoScroll: survey.format === SurveyFormat.OQAAT,
    isFooterEnabled: survey.design?.footer?.enabled,
    isProgressBarEnabled: survey.design?.progressBar?.enabled,
    isQuestionNumberingEnabled: survey.design?.questionNumbering?.enabled,
    isSurveyTitleEnabled: survey.design?.surveyTitle.enabled,
    logo: {
      enabled: survey.design?.logo?.enabled,
      size: survey.design?.logo?.size,
      height: survey.design?.logo?.height,
      width: survey.design?.logo?.width,
      verticalAlignment: survey.design?.logo?.verticalAlignment,
      imageUrl: survey.design?.logo?.image?.url,
      description: survey.design?.logo?.image?.description,
    },
    totalPages: survey.pages?.totalCount,
    showPageTitles: survey.design?.showPageTitles,
    showRequiredQuestionAsterisks: survey.design?.showRequiredQuestionAsterisks,
    surveyTitle: survey.title,
    surveyTitleAlignment: survey.design?.surveyTitle.horizontalAlignment,
    surveyTitleHTML: survey.titleHTML,
    themeVersion: survey.design?.theme?.version,
    totalQuestionsCount: survey.questionCount,
    labels: {
      previous: survey.navigation?.previous.label,
      next: survey.navigation?.next.label,
      done: survey.navigation?.done.label,
      exit: survey.navigation?.exit?.label,
    },
  };
};

export default extrapolateSurveyData;
